import { FC, HTMLAttributes } from 'react'
import { testIds } from '@/root/shared-consts'
import cn from 'classnames'
import { BackLink } from './BackLink'
import { NextButton } from './NextButton'
import { BackButton } from './BackButton'

interface BottomNavButtonsProps extends HTMLAttributes<HTMLDivElement> {
  backSubtitle: string
  backTitle: string
  nextSubtitle: string
  nextTitle: string
  onNext: () => void
  backHref?: string
  nextDisabled?: boolean
  nextLoading?: boolean
  onBack?: () => void
}

export const BottomNavButtons: FC<BottomNavButtonsProps> = ({
  className,
  backHref,
  backTitle,
  backSubtitle,
  nextTitle,
  nextSubtitle,
  nextDisabled,
  nextLoading,
  onNext,
  onBack,
  ...rest
}) => {
  return (
    <div
      data-testid={testIds.bottomNav.container}
      className={cn('flex w-full flex-row items-center justify-between gap-4', className)}
      {...rest}
    >
      {onBack ? (
        <BackButton title={backTitle} subtitle={backSubtitle} onClick={onBack} />
      ) : (
        <BackLink href={backHref ?? ''} title={backTitle} subtitle={backSubtitle} />
      )}
      <NextButton
        title={nextTitle}
        subtitle={nextSubtitle}
        disabled={nextDisabled}
        loading={nextLoading}
        onClick={onNext}
      />
    </div>
  )
}
